<script lang="ts">
	import Bang from '$lib/svg/bang.svg.svelte';
	import BookingSummary from '$lib/widget/components/BookingSummary.svelte';
	import RemainingTimeBeforeExpiration from '$lib/widget/components/RemainingTimeBeforeExpiration.svelte';
	import { widgetCurrentStep } from '$lib/widget/flow';
	import { widgetBooking, widgetBookingError } from '$lib/widget/stores';
	import { fly, slide } from 'svelte/transition';
	interface Props {
		children?: import('svelte').Snippet;
	}

	let { children }: Props = $props();

	$effect(() => {
		if ($widgetBookingError) {
			setTimeout(() => {
				$widgetBookingError = undefined;
			}, 4000);
		}
	});
</script>

<div class="flex flex-col lg:flex-row px-2 overflow-auto">
	<div class="w-full p-2 sm:p-5">
		{#if $widgetBookingError}
			<div
				class="bg-error text-error-on p-4 rounded-lg mt-2 mb-4 animate-pulse flex items-center gap-2"
				transition:slide={{ y: -10, duration: 400, axis: 'y' }}
			>
				<Bang className="w-6 h-6" />
				{$widgetBookingError}
			</div>
		{/if}
		{#if $widgetBooking.id}
			<div class="{$widgetCurrentStep !== 'hub' ? 'lg:hidden' : ''} w-fit *:px-4 mx-auto">
				<RemainingTimeBeforeExpiration />
			</div>
		{/if}
		{@render children?.()}
	</div>

	{#if $widgetBooking.id && $widgetCurrentStep !== 'hub'}
		<div class="w-96 hidden lg:block flex-none" transition:fly={{ x: 100, duration: 300 }}>
			<div class="fixed w-96">
				<BookingSummary
					booking={$widgetBooking}
					hideCustomerRequest
					editable={$widgetCurrentStep !== 'confirmation'}
				/>
			</div>
		</div>
	{/if}
</div>
